import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useNav } from '../lib/nav'
import { Page, TopBar } from '../components/Shell'
import { I } from '../components/Icons'
import { DoneMark } from '../components/DoneMark'
import { fmtC } from '../lib/types'
import type { SaleDoneState } from './SellReview'

export function SellDone() {
  const nav = useNav()
  const s = useLocation().state as SaleDoneState | null
  useEffect(() => { if (!s) nav('/sell', { replace: true }) }, [s, nav])
  if (!s) return null
  const failed = Object.entries(s.stock ?? {}).filter(([, v]) => v.startsWith('failed'))
  return (
    <Page bar={<TopBar title="Sale" />}>
      <div className="done">
        <DoneMark />
        <div className="done__title">Sale complete</div>
        <div className="done__sub">#{s.sale_no} · {fmtC(s.total_cents)} · {s.method} · signed by {s.by.name} ({s.by.employee_id})</div>
        <div className="card done__list done__list--in">
          <div className="done__item"><span className="dot ok">{I.tick(12)}</span><span>Saved to the sales ledger</span></div>
          <div className="done__item"><span className={'dot ' + (failed.length ? 'warn' : 'ok')}>{failed.length ? <span style={{ color: '#fff', fontSize: 12, fontWeight: 700 }}>!</span> : I.tick(12)}</span><span>{failed.length ? `${failed.map(([k]) => k).join(', ')} could not be marked out of stock; mark it in Shopify by hand` : `${s.skus.join(', ')} marked out of stock on Shopify`}</span></div>
          <div className="done__item"><span className="dot ok">{I.tick(12)}</span><span>{s.approved ? `Below-floor price approved by ${s.approved.name}` : 'Owner and split saved with each piece'}</span></div>
        </div>
        <div className="done__btns done__btns--in">
          <button type="button" className="btn-secondary" onClick={() => nav('/')}>Home</button>
          <button type="button" className="cta cta--center" onClick={() => nav('/sell')}>New sale</button>
        </div>
      </div>
    </Page>
  )
}
